import React from 'react'
import { Row, Col, Form, InputGroup } from 'react-bootstrap'
import MaskedInput from 'react-text-mask'
import MomentUtils from '@date-io/moment'
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers'

export default function DadosPessoaisSection({
  cpfMask,
  cpf,
  nome,
  nomeSocial,
  rg,
  dataNascimento,
  invalidCPF,
  carregandoDados,
  camposBloqueados,
  pacienteId,
  allDisabled,
  cpfDisabled,
  onChange,
  onBlurCPF,
  onChangeDate,
}) {
  return (
    <Row className="form-row align-items-start">
      <Col xs={12} lg={2}>
        <Form.Group className="required">
          <Form.Label htmlFor="cpf">CPF</Form.Label>
          <InputGroup>
            <MaskedInput
              mask={cpfMask}
              className={invalidCPF ? 'form-control is-invalid' : 'form-control'}
              name="cpf"
              value={cpf}
              onChange={onChange}
              onBlur={onBlurCPF}
              required
              readOnly={cpfDisabled}
              disabled={cpfDisabled}
            />
            {carregandoDados && (
              <InputGroup.Append>
                <InputGroup.Text>
                  <div className="spinner-border spinner-border-sm" role="status">
                    <span className="sr-only">Carregando...</span>
                  </div>
                </InputGroup.Text>
              </InputGroup.Append>
            )}
          </InputGroup>
          {invalidCPF && <div className="invalid-feedback">Digite um CPF válido.</div>}
          {camposBloqueados && !pacienteId && (
            <small className="form-text text-muted">Digite um CPF válido para buscar e preencher os dados automaticamente.</small>
          )}
        </Form.Group>
      </Col>
      <Col xs={12} lg={3}>
        <Form.Group className="required">
          <Form.Label htmlFor="nome">Nome</Form.Label>
          <Form.Control type="text" name="nome" value={nome} onChange={onChange} required maxLength={100} disabled={allDisabled} />
        </Form.Group>
      </Col>
      <Col xs={12} lg={3}>
        <Form.Group>
          <Form.Label htmlFor="nomeSocial">Nome Social</Form.Label>
          <Form.Control type="text" name="nomeSocial" value={nomeSocial} onChange={onChange} maxLength={100} disabled={allDisabled} />
        </Form.Group>
      </Col>
      <Col xs={12} sm={6} lg={2}>
        <Form.Group className="required">
          <Form.Label htmlFor="rg">RG</Form.Label>
          <Form.Control type="text" name="rg" value={rg} onChange={onChange} required maxLength={10} disabled={allDisabled} />
        </Form.Group>
      </Col>
      <Col xs={12} sm={6} lg={2} className="paciente-form-col-data-nasc">
        <Form.Group className="required">
          <Form.Label htmlFor="dataNascimento">Data de nascimento</Form.Label>
          <MuiPickersUtilsProvider utils={MomentUtils} locale="pt-br">
            <KeyboardDatePicker
              invalidDateMessage="Formato de data inválido"
              name="dataNascimento"
              className={'form-control paciente-form-datepicker-input ' + (allDisabled ? 'disabled-datepicker' : '')}
              value={dataNascimento}
              onChange={(date) => onChangeDate(date)}
              variant="inline"
              format="DD/MM/YYYY"
              required
              animateYearScrolling
              disableFuture
              autoOk
              disabled={allDisabled}
              fullWidth
            />
          </MuiPickersUtilsProvider>
        </Form.Group>
      </Col>
    </Row>
  )
}
